export * from './TS_Space.js';
//# sourceMappingURL=index.js.map